module.exports = __webpack_public_path__ + "img/h1.f6e7b976.jpg";